import React from 'react';
import './testimonial.css';

const Testimonial = ({ title, children, name }) => (
  <div className="testimonial">
    <div className="stars">
      <i class="fa-solid fa-star"></i>
      <i class="fa-solid fa-star"></i>
      <i class="fa-solid fa-star"></i>
      <i class="fa-solid fa-star"></i>
      <i class="fa-solid fa-star"></i>
    </div>
    <h3>{title}</h3>
    <p>{children}</p>
    <p className="author">{name}</p>
  </div>
);

export default Testimonial;
